import MyComputer from "./MyComputer";
export default MyComputer;
